import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getPwmProfileExchangeItemPaginated,
  IPwmProfileExchangeItemPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store";

import { IWesterosPwmExchangeItemModalData } from "./types";
import { WesterosPwmExchangeItemModalMode } from "./enums";

const initialState = {
  exchangeItemList: null as Nullable<
    IPwmProfileExchangeItemPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: WesterosPwmExchangeItemModalMode.VIEW,
  } as IWesterosPwmExchangeItemModalData,
};

export const fetchWesterosPwmExchangeItemList = createAsyncThunk(
  "westeros-pwm-exchange-item/fetchWesterosPwmExchangeItemList",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getPwmProfileExchangeItemPaginated(filters);
    return response;
  }
);

const westerosPwmExchangeItemSlice = createSlice({
  name: "westeros-pwm-exchange-item",
  initialState,
  reducers: {
    setWesterosPwmExchangeItemModalData: (state, action) => {
      state.modalData = action.payload;
    },
    closeWesterosPwmExchangeItemModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchWesterosPwmExchangeItemList.fulfilled,
      (state, action) => {
        return {
          ...state,
          loading: false,
          exchangeItemList: action.payload?.edges ?? null,
          totalCount: action.payload?.totalCount ?? 1,
        };
      }
    );
    builder.addCase(fetchWesterosPwmExchangeItemList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setWesterosPwmExchangeItemModalData,
  closeWesterosPwmExchangeItemModal,
} = westerosPwmExchangeItemSlice.actions;

export default westerosPwmExchangeItemSlice.reducer;
